module.exports = __webpack_public_path__ + "static/How-to-post-a-job-2-e1403553292912-d084588e6e4a16fa3da40fcded2725d1.jpg";